/* eslint-disabled */

export default class SmsTemplateExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
